import { createAction, props } from '@ngrx/store';

import { User } from '../../models';

export const login = createAction('[AUTH] LOGIN');
export const loginSuccess = createAction('[AUTH] LOGIN_SUCCESS', props<{ user: User }>());
export const loginFailure = createAction('[AUTH] LOGIN_FAILURE', props<{ error: string }>());
